// src/helpers/displayCurrency.js
const displayPKRCurrency = (amount) => {
  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
  }).format(amount);
};

export default displayPKRCurrency;
